import { computed, inject } from '@angular/core';
import { patchState, signalStore, withMethods } from '@ngrx/signals';
import {
  entityConfig,
  upsertEntities,
  withEntities,
} from '@ngrx/signals/entities';
import { firstValueFrom } from 'rxjs';
import { WordListService } from '@thiememeulenhoff/ng-api-gateway';
import { WordList } from '@thiememeulenhoff/types';
import {
  toRequestError,
  withRequestStatus,
} from '../_utils/request-status.feature';

const wordListEntityConfig = entityConfig({
  entity: {} as WordList,
  selectId: (e: WordList) => e.id,
});

export const WordListStore = signalStore(
  { providedIn: 'root' },
  withEntities(wordListEntityConfig),
  withRequestStatus(),
  withMethods((store, wordListService = inject(WordListService)) => ({
    wordListById: (id: string) =>
      computed(() => store.entities().find((e) => e.id === id)),
    wordListsByArrangementCode: (arrangementCode: string) =>
      computed(() =>
        store.entities().filter((e) => e.arrangementCode === arrangementCode),
      ),
    wordListsByContentIdentifier: (contentIdentifier: string) =>
      computed(() =>
        store
          .entities()
          .filter((e) => e.resourceContentIdentifier === contentIdentifier),
      ),
    async fetchWordLists(
      arrangementCode: string,
      contentIdentifier?: string,
    ): Promise<void> {
      patchState(store, { requestStatus: 'loading' });
      try {
        const wordLists = await firstValueFrom(
          wordListService.fetchWordLists(arrangementCode, contentIdentifier),
        );
        patchState(store, upsertEntities(wordLists, wordListEntityConfig), {
          requestStatus: 'success',
        });
      } catch (error) {
        patchState(store, {
          requestStatus: toRequestError(error, 'Failed to fetch'),
        });
        throw error;
      }
    },
  })),
);
